import { IActivityLogsListFilters } from '~/services/api/activityLogs/types';
import { getInitialDateRange } from '~/utils/date';

const getInitialValues: () => IActivityLogsListFilters = () => ({
  ...getInitialDateRange(),
});

export default getInitialValues;
